export default "__VITE_ASSET__f4d41464__"